import React from 'react';
import './styles.scss';
import { ReactComponent as OngoingIcon } from 'assets/icons/ongoing.svg';
import { ReactComponent as IncompleteIcon } from 'assets/icons/IncompleteIcon.svg';
import { formatScheduledDeliveryDate } from 'utils/functions';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { OrderType, TrackOrderPillType } from 'models/order.model';

const TrackOrderPill = ({
  type,
  order,
  is_group_order
}: {
  type: TrackOrderPillType;
  order?: OrderType;
  is_group_order?: boolean;
}) => {
  const navigate = useNavigate();
  const bulkOrderMeals = localStorage.getItem(STORAGE_KEYS.ORDER);
  const parsedBulkOrderMeals = bulkOrderMeals ? JSON.parse(bulkOrderMeals) : [];
  const batchOrderMeals = localStorage.getItem(STORAGE_KEYS.BATCH_ORDER);
  const parsedBatchOrderMeals = batchOrderMeals ? JSON.parse(batchOrderMeals) : [];

  const navigateToBasket = () => {
    is_group_order
      ? navigate(ROUTE_KEYS.GROUP_BASKET)
      : parsedBulkOrderMeals?.length > 0
      ? navigate(ROUTE_KEYS.BULK_BASKET)
      : parsedBatchOrderMeals?.length > 0
      ? navigate(ROUTE_KEYS.BATCH_BASKET)
      : undefined;
  };

  const navigateToOngoing = () => navigate(`/orders/${order?.order_code}`);
  return (
    <div
      onClick={type === 'INCOMPLETE' ? navigateToBasket : navigateToOngoing}
      className={`relative cursor-pointer w-full h-[70px] rounded-[100px] track__order__pill px-4 flex items-center justify-between gap-5`}>
      {type === 'ONGOING' ? (
        <p className='text-white text-sm md:whitespace-nowrap'>
          Your order <span className='underline'>#{order?.order_code}</span> is now ongoing, track
          your order
        </p>
      ) : type === 'REVIEW' ? (
        <p className='text-white text-sm md:whitespace-nowrap'>
          Order <span className='underline'>#{order?.order_code}</span> is due by{' '}
          {formatScheduledDeliveryDate(order?.scheduled_delivery_time ?? '')}, you can review within
          24hrs
        </p>
      ) : (
        <p className='text-white text-sm md:whitespace-nowrap'>
          You’re yet to complete your order, view basket
        </p>
      )}
      {type === 'ONGOING' ? (
        <OngoingIcon />
      ) : type === 'REVIEW' ? (
        <button className='rounded-[100px] px-8 py-[10px] bg-white font-medium text-xs text-[#e60a2b]'>
          REVIEW
        </button>
      ) : (
        <IncompleteIcon />
      )}
    </div>
  );
};

export default TrackOrderPill;
